import { BeGrid, BeWindow } from "@beos-css/react/index.ts";
import { useState } from "react";

const STACK_TABS = ["StyledEdit", "Notes", "ToDo"] as const;
type StackTab = (typeof STACK_TABS)[number];
const STACK_CONTENT: Record<StackTab, string> = {
	StyledEdit: "A focused stack: the yellow front tab is StyledEdit. Click a grey tab to switch windows.",
	Notes: "Now showing Notes -- the seam strip moved with the selection.",
	ToDo: "Now showing ToDo. Only the selected tab merges into the body.",
};

export function StackedWindowsDemo() {
	const [stackSel, setStackSel] = useState<StackTab>("StyledEdit");

	return (
		<section id="demo-stacked-windows">
			<h2>Stacked windows (tabbed interface)</h2>
			<p>
				Several windows stacked into one frame, Haiku Stack-&-Tile style: pass <code>tabs</code> to <code>BeWindow</code>. The front tab is
				selected (yellow on a focused window) and keeps the seam strip; the others are <code>unselected</code>. Click a grey tab (or focus
				it and press Enter/Space) to bring its window to the front via <code>onSelect</code>. On an inactive window the whole stack greys
				out but the selected tab still merges into the body.
			</p>
			<BeGrid min={26} align="start" gap="row">
				<BeWindow
					tabs={STACK_TABS.map((t) => ({
						title: t,
						state: t === stackSel ? undefined : "unselected",
						onSelect: t === stackSel ? undefined : () => setStackSel(t),
						onClose: () => {},
						onZoom: t === stackSel ? () => {} : undefined,
					}))}
					contentStyle={{ width: 360, height: 120 }}
				>
					{STACK_CONTENT[stackSel]}
				</BeWindow>
				<BeWindow
					inactive
					tabs={[
						{ title: "StyledEdit", onClose: () => {}, onZoom: () => {} },
						{ title: "Notes", state: "unselected", onClose: () => {} },
						{ title: "ToDo", state: "unselected", onClose: () => {} },
					]}
					contentStyle={{ width: 360, height: 120 }}
				>
					An unfocused stack: all grey; only the front tab keeps the strip.
				</BeWindow>
			</BeGrid>
		</section>
	);
}
